import { ExpensesByMonth, ExpenseStatus } from '@/shared/types/expenses';

export const expenses: ExpensesByMonth[] = [
  {
    id: 2,
    userId: 23456,
    year: 2025,
    month: 4,
    expensesStatus: ExpenseStatus.CREATED,
    expenses: [
      {
        id: 1,
        date: '2025-04-05',
        type: 'Transport',
        description: 'Uber Paris',
        amount: 25.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/uber.pdf',
      },
      {
        id: 2,
        date: '2025-04-12',
        type: 'Restauration',
        description: 'Déjeuner client',
        amount: 42.5,
        status: ExpenseStatus.PENDING,
        receiptUrl: '/receipts/lunch.pdf',
        // En attente mais déjà un échange
        lastComment: "Merci d'ajouter le nom du client sur la note.",
        statusHistory: [
          {
            status: ExpenseStatus.PENDING,
            comment:
              'Ticket illisible sur la date. Pouvez-vous reprendre une photo et préciser le client ?',
            author: 'Sophie (RH)',
            at: '2025-04-13T10:24:00Z',
          },
          {
            status: ExpenseStatus.PENDING,
            comment: "J'ai ré-uploadé le ticket. Manque-t-il autre chose ?",
            author: 'Kevin FEWOU',
            at: '2025-04-13T15:02:00Z',
          },
          {
            status: ExpenseStatus.PENDING,
            comment: "Merci d'ajouter le nom du client sur la note.",
            author: 'Sophie (RH)',
            at: '2025-04-13T16:18:00Z',
          },
        ],
      },
      {
        id: 3,
        date: '2025-04-20',
        type: 'Hébergement',
        description: 'Hôtel Lyon',
        amount: 120.0,
        status: ExpenseStatus.REFUSED,
        receiptUrl: '/receipts/hotel.pdf',
        lastComment:
          'Le plafond hôtel dépassé pour Lyon. Merci de justifier ou corriger le montant.',
        statusHistory: [
          {
            status: ExpenseStatus.PENDING,
            comment: 'Note soumise.',
            author: 'Kevin FEWOU',
            at: '2025-04-20T08:00:00Z',
          },
          {
            status: ExpenseStatus.REFUSED,
            comment:
              'Le plafond hôtel dépassé pour Lyon. Merci de justifier ou corriger le montant.',
            author: 'Sophie (RH)',
            at: '2025-04-21T09:15:00Z',
          },
        ],
      },
      {
        id: 4,
        date: '2025-04-06',
        type: 'Restauration',
        description: 'Déjeuner projet',
        amount: 28.0,
        status: ExpenseStatus.REFUSED,
        receiptUrl: '/receipts/lunch.pdf',
        lastComment: 'Le reçu ne mentionne pas la date.',
        statusHistory: [
          {
            status: ExpenseStatus.PENDING,
            comment: 'Soumission initiale.',
            author: 'Kevin FEWOU',
            at: '2025-04-06T12:20:00Z',
          },
          {
            status: ExpenseStatus.REFUSED,
            comment: 'Le reçu ne mentionne pas la date.',
            author: 'Sophie (RH)',
            at: '2025-04-07T09:40:00Z',
          },
        ],
      },
      {
        id: 5,
        date: '2025-04-07',
        type: 'Transport',
        description: 'Transport bus',
        amount: 15.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/uber.pdf',
      },
      {
        id: 6,
        date: '2025-04-08',
        type: 'Transport',
        description: 'Parking',
        amount: 20.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/uber.pdf',
      },
      {
        id: 7,
        date: '2025-04-09',
        type: 'Restauration',
        description: 'Petit-déjeuner client',
        amount: 10.0,
        status: ExpenseStatus.PENDING,
        receiptUrl: '/receipts/lunch.pdf',
        lastComment: 'Merci de préciser le contexte (réunion, déplacement...).',
        statusHistory: [
          {
            status: ExpenseStatus.PENDING,
            comment: 'Manque le contexte de dépense.',
            author: 'Sophie (RH)',
            at: '2025-04-09T18:10:00Z',
          },
          {
            status: ExpenseStatus.PENDING,
            comment: 'Merci de préciser le contexte (réunion, déplacement...).',
            author: 'Sophie (RH)',
            at: '2025-04-10T08:05:00Z',
          },
        ],
      },
      {
        id: 8,
        date: '2025-04-10',
        type: 'Transport',
        description: 'Location voiture',
        amount: 90.0,
        status: ExpenseStatus.VALIDATED,
      },
      {
        id: 9,
        date: '2025-04-11',
        type: 'Transport',
        description: 'Billet train',
        amount: 70.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/uber.pdf',
      },
      {
        id: 10,
        date: '2025-04-12',
        type: 'Autres',
        description: 'Frais bancaire',
        amount: 5.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/frais.pdf',
      },
      {
        id: 11,
        date: '2025-04-13',
        type: 'Autres',
        description: 'Cadeau client',
        amount: 50.0,
        status: ExpenseStatus.PENDING,
        receiptUrl: '/receipts/cadeau.pdf',
      },
      {
        id: 12,
        date: '2025-04-10',
        type: 'Transport',
        description: 'Location bateau',
        amount: 960.0,
        status: ExpenseStatus.REFUSED,
        receiptUrl: '/receipts/uber.pdf',
        lastComment: 'Dépense non éligible.',
        statusHistory: [
          {
            status: ExpenseStatus.REFUSED,
            comment: 'Dépense non éligible.',
            author: 'Sophie (RH)',
            at: '2025-04-11T10:30:00Z',
          },
        ],
      },
      {
        id: 13,
        date: '2025-04-11',
        type: 'Transport',
        description: 'Billet train',
        amount: 70.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/uber.pdf',
      },
      {
        id: 14,
        date: '2025-04-12',
        type: 'Autres',
        description: 'Frais notaire',
        amount: 25.0,
        status: ExpenseStatus.REFUSED,
        receiptUrl: '/receipts/frais.pdf',
        lastComment: 'Frais personnels non remboursables.',
        statusHistory: [
          {
            status: ExpenseStatus.REFUSED,
            comment: 'Frais personnels non remboursables.',
            author: 'Sophie (RH)',
            at: '2025-04-12T14:20:00Z',
          },
        ],
      },
      {
        id: 15,
        date: '2025-04-13',
        type: 'Autres',
        description: 'Cadeau tchiza',
        amount: 56.0,
        status: ExpenseStatus.REFUSED,
        receiptUrl: '/receipts/cadeau.pdf',
        lastComment: 'Non conforme à la politique cadeaux.',
        statusHistory: [
          {
            status: ExpenseStatus.REFUSED,
            comment: 'Non conforme à la politique cadeaux.',
            author: 'Sophie (RH)',
            at: '2025-04-14T09:00:00Z',
          },
        ],
      },
    ],
  },
  {
    id: 1,
    userId: 23456,
    year: 2025,
    month: 3,
    expensesStatus: ExpenseStatus.VALIDATED,
    expenses: [
      {
        id: 1,
        date: '2025-04-05',
        type: 'Transport',
        description: 'Uber Paris',
        amount: 25.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/uber.pdf',
      },
      {
        id: 2,
        date: '2025-04-12',
        type: 'Restauration',
        description: 'Déjeuner client',
        amount: 42.5,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/lunch.pdf',
      },
      {
        id: 3,
        date: '2025-04-20',
        type: 'Hébergement',
        description: 'Hôtel Lyon',
        amount: 120.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/hotel.pdf',
      },
      {
        id: 4,
        date: '2025-04-06',
        type: 'Restauration',
        description: 'Déjeuner projet',
        amount: 28.0,
        status: ExpenseStatus.VALIDATED,
        receiptUrl: '/receipts/lunch.pdf',
      },
    ],
  },
];
